import { track } from "@/lib/analytics";

/**
 * Inline link that points to the campaign/affiliate questionnaire URL.
 * Used to make every mention of "שאלון האבחון" inside funnel guides clickable.
 *
 * Props:
 *   - lead: { affiliate_url, campaign_id, lead_id }
 *   - source: string id for analytics (e.g. "guide1_what_next")
 *   - children: visible link text
 */
export default function QuizLink({ lead, source, children, className = "" }) {
  if (!lead?.affiliate_url) {
    // No URL configured yet — render plain text so we never break the copy.
    return <span>{children}</span>;
  }
  const onClick = () =>
    track("funnel_affiliate_click", {
      campaignId: lead.campaign_id,
      leadId: lead.lead_id,
      payload: { source },
    });
  return (
    <a
      href={lead.affiliate_url}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
      data-testid={`quiz-link-${source}`}
      className={`font-bold underline decoration-2 underline-offset-2 hover:opacity-80 transition ${className || "text-brand-amber"}`}
    >
      {children}
    </a>
  );
}
